import React, { ReactNode, createContext, useContext } from 'react';
import { FilterSelectionStateGroup } from '../types';

const GroupContext = createContext<FilterSelectionStateGroup | null>(null);

interface Props {
  group: FilterSelectionStateGroup | null;
  children: ReactNode;
}

export function GroupProvider({ children, group }: Props) {
  return <GroupContext.Provider value={group}>{children}</GroupContext.Provider>;
}

export function useGroupContext() {
  return useContext(GroupContext);
}
